import { mapObject } from '@shared/helpers/object.helpers';
import {
  foldConservativeDeltasFlat,
  stripConservativeDeltasFlat,
} from '@shared/helpers/conservative-carbon.helpers';
import { filterResultsByLifecycles } from '@shared/helpers/lifecycles.helpers';
import { getFlatResults } from '@shared/helpers/sbef-results.helpers';
import type { Lifecycle } from '@shared/models/lifecycles.model';
import type { ResultsRecord } from '@shared/models/unit.model';

type FilterProductGroupChartResultsRecordOptions = {
  lifecycles: Lifecycle[];
  conservative: boolean;
};

/**
 * Prepare a proposal {@link ResultsRecord} for the product-groups donut.
 * SBEF scope is applied through {@link createProductListCategoryGroups} tree
 * filtering, not by collapsing each row with {@link filterResultsBySbefGroups}.
 * Product rows often carry flat totals only; row-level SBEF collapse would zero
 * them out under a partial scope selection even when those products belong to
 * selected SBEF groups.
 */
export const filterProductGroupChartResultsRecord = (
  record: ResultsRecord,
  options: FilterProductGroupChartResultsRecordOptions,
): ResultsRecord => {
  const transform = options.conservative
    ? foldConservativeDeltasFlat
    : stripConservativeDeltasFlat;

  return mapObject(record, (results) =>
    filterResultsByLifecycles(
      transform(getFlatResults(results)),
      options.lifecycles,
    ),
  );
};
